export var initFirstLetterBig = function initFirstLetterBig() {
  var article = document.querySelector("article.article");
  var firstLetter = article.querySelector('h2').innerText[0];
  var backgroundLetterWrapper = article.querySelector('.background-letter-wrapper');
  var colors = ['#DDBE78', '#F0E9E1', '#5C74DC', '#449A51', '#F9C300', '#81C0AF', '#FDB99D'];
  backgroundLetterWrapper.innerText = firstLetter;
  backgroundLetterWrapper.style.color = colors[Math.floor(Math.random() * (colors.length - 1 - 0)) + 0];
};